export default "__VITE_ASSET__tZU6DvUG__"